import { fenToWan } from '../../utils/unit-conversion';
import { formatTime } from './trans-data-util';
var gLineScale = [
    {
        dataKey: 'xAxis',
        alias: '日期',
    },
    {
        dataKey: 'yAxis',
        alias: '出险次数',
    },
];
var chartLine = {
    data: [],
    scale: gLineScale,
    height: 400,
};
/**
 *  chart line2 options
 * */
var gLine2Scale = [
    {
        dataKey: 'xAxis',
        alias: '日期',
    },
    {
        dataKey: 'money',
        formatter: function (value) { return '￥' + fenToWan(value) + '万'; },
    },
];
var chartLine2 = {
    data: [],
    scale: gLine2Scale,
    height: 400,
    style: { stroke: '#fff', lineWidth: 1 },
};
/**
 * chart histogram data
 */
var histTooltip = [
    'xAxis*yAxis',
    function (x, y) { return ({
        name: x,
        value: y,
    }); },
];
var histScale = [
    {
        dataKey: 'xAxis',
    },
    {
        dataKey: 'yAxis',
        alias: '时效',
        formatter: function (value) { return formatTime(value); },
    },
];
var chartHistogram = {
    data: [],
    scale: histScale,
    tooltip: histTooltip,
    height: 400,
};
export { chartLine, chartLine2, chartHistogram };
